<script setup>
import { ref, reactive, computed, onMounted, defineComponent, onBeforeUnmount, defineExpose } from 'vue'
import { showToast } from 'vant';
import JSMpeg from 'jsmpeg-player';
import copy from 'copy-to-clipboard'
import { Swiper, SwiperSlide } from 'swiper/vue'
import 'swiper/css'
import "swiper/css/navigation";
import { Navigation, Mousewheel } from 'swiper/modules';
import { userInfoStore, rewardListStore } from '@/stores/counter.js'
import { getReqData } from '@/util/api'

const modules = ref([Navigation, Mousewheel])
const ElementSwiper = defineComponent(Swiper)
const ElementSwiperSlide = defineComponent(SwiperSlide)
const swiperInstance = ref();
const swiperIndex = ref(0)
const userStore = userInfoStore()
const rewardStore = rewardListStore()
const userInfo = computed(() => {
  return userStore.userInfo
})
const videoCanvas = ref()
const sildeIndex = ref(0)
const playerVideo = ref('')

const onSwiper = (swp) => {
  swiperInstance.value = swp
}
const onSlideChange = (index) => {
  console.log('【切换】', index);
  
  swiperIndex.value = index.activeIndex
}
const slidePrev = (data) => {
  console.log('【回到第一个】');
  sildeIndex.value = data
  audioPlay()
  if (swiperInstance.value) {
    swiperInstance.value.slidePrev()
  }
}
const slideNext = (data) => {
  console.log('【回到第一个】');
  sildeIndex.value = data
  audioPlay()
  if (swiperInstance.value) {
    swiperInstance.value.slideNext()
  }
}

const audioPlay = () => {
  const idText = 'audioMp' + sildeIndex.value
  console.log('【播放音频】', idText);
  if (document.getElementById(idText)) {
    document.getElementById(idText).play()
  }
}

const initVideoStream = () => {
  const videoUrl = 'https://onepiece.hllcmt.com/static/ts/video.ts';
  playerVideo.value = new JSMpeg.VideoElement(videoCanvas.value, videoUrl, { autoplay: true,
    poster: 'https://onepiece.hllcmt.com/static/ts/video.png',
    loop: true,
    control: false,
    disableGl: false,
    progressive: false,
    preserveDrawingBuffer: false,
    decodeFirstFrame: false
  }, 
  { audio: false, onPlay: () => {
    console.log('【开始播放】');
  } })
}

defineExpose({ audioPlay })

onMounted(() => {
  initVideoStream()
  // audioPlay()
})
onBeforeUnmount(() => {
  playerVideo.value.destroy()
  console.log('【销毁】');
  
})
</script>

<template>
  <section class="home-box">
    <section ref="videoCanvas" class="videoBox" style="width: 100%; height: 100%;"></section>
    <section style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;">
      <ElementSwiper
        @swiper="onSwiper"
        @slideChange="onSlideChange"
        :slides-per-view="1"
        :initialSlide="0"
        :modules="modules"
        :space-between="0"
        :direction="'horizontal'"
        :loop="true"
        style="width: 100%; height: 100%;"
      >
        <ElementSwiperSlide>
          <section class="slide-box">
            <img src="@/assets/img/02p/title01m.png" alt="" style="width: 317px; margin-top: 0.70rem;">
            <img src="@/assets/img/02p/name01m.png" alt="" style="height: 0.7rem; margin-top: 0.22rem;">
            <aside style="display: flex; justify-content: center; align-items: center;">
              <img src="@/assets/img/02p/qie-left.png" alt="" @click="slidePrev('4')" style="width: 50px;">
              <img src="@/assets/img/02p/rw01m-m.png" alt="" style="width: 248px; margin: 0px 6px;">
              <img src="@/assets/img/02p/qie-right.png" alt="" @click="slideNext('1')" style="width: 50px;">
            </aside>
            <section class="introd-box" style="display: flex; justify-content: center; align-items: center;">
              <img src="@/assets/img/02p/jn01.png" alt="" style="width: 324px;">
              <!-- <aside class="jn-box">
                <img src="@/assets/img/02p/jn01m.png" alt="" style="width: 0.6rem; margin-right: 4px;">
                <aside style="display: flex; flex-direction: column;">
                  <span class="jn-name">니카 루피</span>
                  <span style="font-size: 0.09rem; color: rgb(76, 62, 33);">[스킬] 고무고무 번개
                    번개를 던져 처음 명중한 대상 위치에 [뇌전 폭풍]을 일으킵니다. 범위 내 모든 적에게 공격력의 60%만큼 [번개] 속성 피해를 주고, 2초 동안 [속박] 효과를 부여합니다. 쿨타임 8.5초</span>
                </aside>
              </aside>
              <aside class="jn-box">
                <img src="@/assets/img/02p/jn02m.png" alt="" style="width: 0.6rem; margin-right: 4px;">
                <aside style="display: flex; flex-direction: column;">
                  <span class="jn-name">니카 루피</span>
                  <span style="font-size: 0.09rem; color: rgb(76, 62, 33);">[스킬] 고무고무 번개
                    번개를 던져 처음 명중한 대상 위치에 [뇌전 폭풍]을 일으킵니다. 범위 내 모든 적에게 공격력의 60%만큼 [번개] 속성 피해를 주고, 2초 동안 [속박] 효과를 부여합니다. 쿨타임 8.5초</span>
                </aside>
              </aside> -->
            </section>
            <audio id="audioMp0">
              <source src="@/assets/img/02p/rwmp01.mp3" type="audio/mpeg">
            </audio>
          </section>
        </ElementSwiperSlide>
        <ElementSwiperSlide>
          <section class="slide-box">
            <img src="@/assets/img/02p/title01m.png" alt="" style="width: 317px; margin-top: 0.70rem;">
            <img src="@/assets/img/02p/name02m.png" alt="" style="height: 0.7rem; margin-top: 0.22rem;">
            <aside style="display: flex; justify-content: center; align-items: center;">
              <img src="@/assets/img/02p/qie-left.png" alt="" @click="slidePrev('0')" style="width: 50px;">
              <img src="@/assets/img/02p/rw02-m.png" alt="" style="width: 248px; margin: 0px 6px;">
              <img src="@/assets/img/02p/qie-right.png" alt="" @click="slideNext('2')" style="width: 50px;">
            </aside>
            <section class="introd-box" style="display: flex; justify-content: center; align-items: center;">
              <img src="@/assets/img/02p/jn02.png" alt="" style="width: 324px;">
            </section>
            <audio id="audioMp1">
              <source src="@/assets/img/02p/rwmp02.mp3" type="audio/mpeg">
            </audio>
          </section>
        </ElementSwiperSlide>
        <ElementSwiperSlide>
          <section class="slide-box">
            <img src="@/assets/img/02p/title01m.png" alt="" style="width: 317px; margin-top: 0.70rem;">
            <img src="@/assets/img/02p/name03m.png" alt="" style="height: 0.7rem; margin-top: 0.22rem;">
            <aside style="display: flex; justify-content: center; align-items: center;">
              <img src="@/assets/img/02p/qie-left.png" alt="" @click="slidePrev('1')" style="width: 50px;">
              <img src="@/assets/img/02p/rw03-m.png" alt="" style="width: 248px; margin: 0px 6px;">
              <img src="@/assets/img/02p/qie-right.png" alt="" @click="slideNext('3')" style="width: 50px;">
            </aside>
            <section class="introd-box" style="display: flex; justify-content: center; align-items: center;">
              <img src="@/assets/img/02p/jn03.png" alt="" style="width: 324px;">
            </section>
            <audio id="audioMp2">
              <source src="@/assets/img/02p/rwmp03.mp3" type="audio/mpeg">
            </audio>
          </section>
        </ElementSwiperSlide>
        <ElementSwiperSlide>
          <section class="slide-box">
            <img src="@/assets/img/02p/title01m.png" alt="" style="width: 317px; margin-top: 0.70rem;">
            <img src="@/assets/img/02p/name04m.png" alt="" style="height: 0.7rem; margin-top: 0.22rem;">
            <aside style="display: flex; justify-content: center; align-items: center;">
              <img src="@/assets/img/02p/qie-left.png" alt="" @click="slidePrev('2')" style="width: 50px;">
              <img src="@/assets/img/02p/rw04-m.png" alt="" style="width: 248px; margin: 0px 6px;">
              <img src="@/assets/img/02p/qie-right.png" alt="" @click="slideNext('4')" style="width: 50px;">
            </aside>
            <section class="introd-box" style="display: flex; justify-content: center; align-items: center;">
              <img src="@/assets/img/02p/jn04.png" alt="" style="width: 324px;">
            </section>
            <audio id="audioMp3">
              <source src="@/assets/img/02p/rwmp04.mp3" type="audio/mpeg">
            </audio>
          </section>
        </ElementSwiperSlide>
        <ElementSwiperSlide>
          <section class="slide-box">
            <img src="@/assets/img/02p/title01m.png" alt="" style="width: 317px; margin-top: 0.70rem;">
            <img src="@/assets/img/02p/name05m.png" alt="" style="height: 0.7rem; margin-top: 0.22rem;">
            <aside style="display: flex; justify-content: center; align-items: center;">
              <img src="@/assets/img/02p/qie-left.png" alt="" @click="slidePrev('3')" style="width: 50px;">
              <img src="@/assets/img/02p/rw05-m.png" alt="" style="width: 248px; margin: 0px 6px;">
              <img src="@/assets/img/02p/qie-right.png" alt="" @click="slideNext('0')" style="width: 50px;">
            </aside>
            <section class="introd-box" style="display: flex; justify-content: center; align-items: center;">
              <img src="@/assets/img/02p/jn05.png" alt="" style="width: 324px;">
            </section>
            <audio id="audioMp4">
              <source src="@/assets/img/02p/rwmp05.mp3" type="audio/mpeg">
            </audio>
          </section>
        </ElementSwiperSlide>
      </ElementSwiper>
    </section>
  </section>
</template>

<style scoped>
.home-box {
  width: 100%;
  height: 100vh;
  position: relative;
  background: url('../../assets/img/02p/bac2.jpg') no-repeat;
  background-size: cover;
  background-position: center;
  position: relative;
}
.slide-box {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.introd-box {
  width: 100%;
  height: 2.12rem;
  display: flex;
  flex-direction: column;
  background: url('../../assets/img/02p/int-bac.png') no-repeat;
  background-size: 100% 100%;
  margin-top: -20px;
  padding-top: 20px;
}
.jn-box {
  display: flex;
  align-items: flex-start;
  margin: 0.22rem 28px 0px 20px;
}
.jn-name {
  display: block;
  background: url('../../assets/img/02p/jn-name-bac.png') no-repeat;
  background-size: 100% 100%;
  font-size: 0.09rem;
  color: rgb(255, 247, 184);
  width: auto;
  width: fit-content;
  padding: 8px 18px 2px;
  margin-bottom: 4px;
}

.text-sys2 {
  font-size: 14px;
  font-weight: bolder;
  color: #9d4f23;
  /* text-shadow: -0.2px -0.2px 0 #fff1d6, 0.2px -0.2px 0 #fff1d6, -0.2px 0.2px 0 #fff1d6, 0.2px 0.2px 0 #fff1d6; */
}
.text-sys3 {
  font-size: 14px;
  /* font-weight: bolder; */
  color: #443421;
  /* text-shadow: -0.2px -0.2px 0 #fff1d6, 0.2px -0.2px 0 #fff1d6, -0.2px 0.2px 0 #fff1d6, 0.2px 0.2px 0 #fff1d6; */
}
.videoBox {
  object-fit: cover;
  z-index: 0;
}
</style>
